(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-hiw-slider')) {
    customElements.define('tcc-hiw-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tcc-hiw-track]');
        this.slides = Array.from(this.querySelectorAll('[data-tcc-hiw-slide]'));
        this.prev = this.querySelector('[data-tcc-hiw-prev]');
        this.next = this.querySelector('[data-tcc-hiw-next]');
        this.dots = Array.from(this.querySelectorAll('[data-tcc-hiw-dot]'));
        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);

        if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
        if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.tccHiwDot)));
        });

        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) this.goTo(i);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.update();
      }

      goTo(i) {
        const target = Math.max(0, Math.min(this.slides.length - 1, i));
        const left = this.slides[target].offsetLeft - this.slides[0].offsetLeft;
        this.track.scrollTo({ left: left, behavior: 'smooth' });
      }

      update() {
        const scrollLeft = this.track.scrollLeft;
        const start = this.slides[0].offsetLeft;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        let active = 0;
        let best = Infinity;
        this.slides.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - start - scrollLeft);
          if (d < best) { best = d; active = i; }
        });
        if (maxScroll > 0 && scrollLeft >= maxScroll - 2) active = this.slides.length - 1;
        this.index = active;

        this.dots.forEach((dot, i) => {
          const on = i === active;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.prev) this.prev.disabled = active === 0;
        if (this.next) this.next.disabled = active === this.slides.length - 1;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-before-after-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-ba-video-player')) {
    customElements.define('tcc-ba-video-player', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.dataset.autoplay !== 'true') return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.reduceMotion) {
          this.video.pause();
          this.video.removeAttribute('autoplay');
          this.video.controls = true;
          return;
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const p = this.video.play();
                if (p && p.catch) p.catch(() => {});
              } else {
                this.video.pause();
              }
            });
          }, { threshold: 0.15 });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-footer-payments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-fb-cta-sticky')) {
    class TccFbCtaSticky extends HTMLElement {
      connectedCallback() {
        this.stickyDesktop = this.dataset.stickyDesktop === 'true';
        this.stickyMobile = this.dataset.stickyMobile === 'true';
        if (!this.stickyDesktop && !this.stickyMobile) return;
        this.strip = this.querySelector('.tcc-fb-cta');
        if (!this.strip || !('IntersectionObserver' in window)) return;

        this.inView = true;
        this.mq = window.matchMedia('(min-width: 990px)');
        this.onChange = () => this.update();

        // Watch the wrapper (it keeps the strip's space in the layout while stuck)
        this.io = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.update();
        });
        this.io.observe(this);
        this.mq.addEventListener('change', this.onChange);

        // Gate: the bar only appears once the shopper has scrolled PAST the
        // add-to-cart (data-hide-when). It hides again while that element is on
        // screen or still below the fold. States: visible | above | below | hidden.
        this.hiderState = new Map();
        this.hidersReady = true;
        const selector = (this.dataset.hideWhen || '').trim();
        if (selector) {
          let hiders = [];
          try {
            hiders = Array.from(document.querySelectorAll(selector)).filter((el) => !this.contains(el));
          } catch (e) {
            console.warn('TCC Footer Bottom: invalid sticky bar selector:', selector);
          }
          if (hiders.length) {
            this.hidersReady = false; // wait for the first observation, so nothing flashes on load
            this.hideIo = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                const r = entry.boundingClientRect;
                let state;
                if (r.width === 0 && r.height === 0) {
                  state = 'hidden'; // display:none (e.g. a desktop-only duplicate)
                } else if (entry.isIntersecting) {
                  state = 'visible';
                } else {
                  const top = entry.rootBounds ? entry.rootBounds.top : 0;
                  state = r.bottom <= top ? 'above' : 'below';
                }
                this.hiderState.set(entry.target, state);
              });
              this.hidersReady = true;
              this.update();
            });
            hiders.forEach((el) => this.hideIo.observe(el));
          }
        }

        // Fallback when there's no add-to-cart on the page (or it's hidden):
        // show only after scrolling one full screen.
        this.pastFold = false;
        this.onScroll = () => {
          const past = window.scrollY > window.innerHeight;
          if (past !== this.pastFold) {
            this.pastFold = past;
            this.update();
          }
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      allowed() {
        return this.mq.matches ? this.stickyDesktop : this.stickyMobile;
      }

      passedGate() {
        if (!this.hidersReady) return false;
        const states = Array.from(this.hiderState.values()).filter((st) => st !== 'hidden');
        if (states.length) return !states.includes('visible') && states.includes('above');
        return this.pastFold;
      }

      update() {
        const stick = this.allowed() && !this.inView && this.passedGate();
        const wasStuck = this.classList.contains('is-stuck');
        if (stick && !wasStuck) {
          // Measure the strip in its normal (unstuck) state so the placeholder matches
          this.style.minHeight = this.strip.offsetHeight + 'px';
        } else if (!stick) {
          this.style.minHeight = '';
        }
        this.classList.toggle('is-stuck', stick);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.hideIo) this.hideIo.disconnect();
        if (this.mq) this.mq.removeEventListener('change', this.onChange);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
    }
    customElements.define('tcc-fb-cta-sticky', TccFbCtaSticky);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-image-fixed-sliders"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-ifs-slider')) {
    customElements.define('tcc-ifs-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tcc-ifs__track');
        if (!this.track) return;

        this.onClick = (e) => {
          const btn = e.target.closest('[data-dir]');
          if (btn && this.contains(btn)) this.go(Number(btn.dataset.dir));
        };
        this.addEventListener('click', this.onClick);

        this.update = () => {
          this.toggleAttribute('data-overflow', this.track.scrollWidth > this.track.clientWidth + 2);
        };
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.track);
        this.update();

        this.onSelect = (e) => {
          const slide = e.target;
          if (slide instanceof Element && this.contains(slide)) {
            slide.scrollIntoView({ block: 'nearest', inline: 'center' });
          }
        };
        document.addEventListener('shopify:block:select', this.onSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.ro) this.ro.disconnect();
      }

      step() {
        const slides = this.track.children;
        return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : this.track.clientWidth;
      }

      go(dir) {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        if (dir > 0 && t.scrollLeft >= max - 2) return t.scrollTo({ left: 0 });
        if (dir < 0 && t.scrollLeft <= 2) return t.scrollTo({ left: max });
        t.scrollBy({ left: dir * this.step() });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-interactive-listicle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-listicle')) {
    customElements.define('tcc-listicle', class TccListicle extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.id_ = this.dataset.sectionId;
        this.design = this.dataset.design === 'true';
        this.useHistory = this.dataset.history === 'true' && !this.design && !!window.history.pushState;
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.segs = Array.from(this.querySelectorAll('[data-seg]'));
        this.fill = this.querySelector('[data-fill]');
        this.progress = this.querySelector('[data-progress]');
        this.currentEl = this.querySelector('[data-current]');
        this.offerBar = this.querySelector('[data-offerbar]');
        this.offerTimer = this.querySelector('[data-offerbar-timer]');
        this.editorKey = 'tcc-listicle-editor-' + this.id_;
        this.index = 0;
        this.pushes = 0;
        this.picked = '';
        if (!this.steps.length) return;

        this._onClick = this.onClick.bind(this);
        this._onChange = this.onChange.bind(this);
        this._onInput = this.onInput.bind(this);
        this._onShow = () => {
          this.querySelectorAll('.is-loading').forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
          this.unlockIfIdle();
        };
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
        this.addEventListener('input', this._onInput);
        window.addEventListener('pageshow', this._onShow);

        this._onScroll = () => {
          if (this._dockRaf) return;
          this._dockRaf = requestAnimationFrame(() => { this._dockRaf = null; this.dock(); });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(this._onScroll);
          this._ro.observe(this);
        }

        if (this.useHistory) {
          this._onPop = (e) => {
            if (this._ignorePop) { this._ignorePop = false; clearTimeout(this._ignoreT); return; }
            const st = e.state;
            if (!st || st.tccListicle !== this.id_) return;
            const i = Number(st.tccStep) || 0;
            this.pushes += i > this.index ? 1 : -1;
            if (this.pushes < 0) this.pushes = 0;
            this.go(i, { fromHistory: true });
          };
          window.addEventListener('popstate', this._onPop);
          try { if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual'; } catch (err) {}
        }

        if (this.design) {
          this._onSelect = (e) => {
            if (e.detail && e.detail.sectionId === this.id_) this.goToBlock(e.detail.blockId);
          };
          document.addEventListener('shopify:block:select', this._onSelect);
        }

        this.initDates();
        this.initTimer();
        this.initDrawers();
        this.lightbox = this.querySelector('[data-lightbox]');
        if (this.lightbox) {
          this.lightbox.addEventListener('cancel', (e) => { e.preventDefault(); this.lightboxClose(); });
          this.lightbox.addEventListener('click', (e) => { if (e.target === this.lightbox) this.lightboxClose(); });
        }
        this.initSwipe();
        this.initScrollGuard();
        this.querySelectorAll('[data-rev-track]').forEach((t) => {
          t.addEventListener('scroll', () => this.revArrows(t.closest('[data-revs]')), { passive: true });
        });

        let start = 0;
        if (this.design) {
          let saved = null;
          try { saved = sessionStorage.getItem(this.editorKey); } catch (err) {}
          const si = saved ? this.steps.findIndex((s) => s.dataset.blockId === saved) : -1;
          if (si > -1) start = si;
        } else if (this.useHistory) {
          const st = window.history.state;
          if (st && st.tccListicle === this.id_) start = Number(st.tccStep) || 0;
          this.replace(start);
        }
        this.go(start, { initial: true });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('input', this._onInput);
        window.removeEventListener('pageshow', this._onShow);
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this._ro) this._ro.disconnect();
        if (this._dockRaf) cancelAnimationFrame(this._dockRaf);
        this._dockRaf = null;
        if (this._onPop) window.removeEventListener('popstate', this._onPop);
        if (this._onSelect) document.removeEventListener('shopify:block:select', this._onSelect);
        if (this.timerId) clearInterval(this.timerId);
        if (this._onClickCap) this.removeEventListener('click', this._onClickCap, true);
        if (this._onKey) window.removeEventListener('keydown', this._onKey);
        this.classList.remove('is-swiping');
        if (this._swTimer) clearTimeout(this._swTimer);
        if (this._ignoreT) clearTimeout(this._ignoreT);
        if (this._sgMo) this._sgMo.disconnect();
        if (this._sgRaf) cancelAnimationFrame(this._sgRaf);
        this._sgRaf = null;
        document.documentElement.classList.remove('tcc-listicle-unlock');
        (this.drawers || []).forEach((d) => { try { if (d.open) d.close(); } catch (err) {} });
        if (this.lightbox && this.lightbox.open) { try { this.lightbox.close(); } catch (err) {} }
        document.documentElement.classList.remove('tcc-listicle-lock');
        this._ready = false;
      }

      /* ---------- Navigation ---------- */
      unlockIfIdle() {
        const anyOpen = (this.drawers || []).some((d) => d.open) || (this.lightbox && this.lightbox.open);
        if (!anyOpen) document.documentElement.classList.remove('tcc-listicle-lock');
      }

      go(i, opts = {}) {
        i = Math.max(0, Math.min(i, this.steps.length - 1));
        const step = this.steps[i];
        const back = opts.back !== undefined ? opts.back : i < this.index;
        const changed = i !== this.index;
        this.index = i;

        (this.drawers || []).forEach((d) => { if (d.open && !step.contains(d)) this.closeDrawer(d, true); });
        this.swipeReset();

        this.steps.forEach((s) => {
          if (s === step) return;
          s.hidden = true;
          s.classList.remove('is-entering', 'is-back');
          this.media(s, false);
        });
        step.hidden = false;
        this.media(step, true);
        this.warm(i + 1);

        if (!opts.initial) {
          step.classList.remove('is-entering', 'is-back');
          void step.offsetWidth;
          step.classList.add('is-entering');
          if (back) step.classList.add('is-back');
          if (!this.design) {
            const top = this.getBoundingClientRect().top;
            if (top < 0) window.scrollTo(0, top + window.scrollY);
            const focus = step.querySelector('[data-step-focus]');
            if (focus) focus.focus({ preventScroll: true });
          }
          if (this.useHistory && !opts.fromHistory && changed) {
            window.history.pushState({ tccListicle: this.id_, tccStep: i }, '');
            this.pushes++;
          }
          if (changed) this.track(step, i);
        }

        if (this.design) {
          try { sessionStorage.setItem(this.editorKey, step.dataset.blockId); } catch (err) {}
          const pv = step.querySelector('[data-drawer][data-preview]');
          if (pv) this.openDrawer(pv);
        }
        step.querySelectorAll('[data-revs]').forEach((w) => this.revArrows(w));
        this.unlockIfIdle();
        if (this._sgCheck) this._sgCheck();
        this.chrome();
        this.dock();
      }

      dock() {
        const step = this.steps[this.index];
        const slot = step ? step.querySelector('[data-bar-slot]') : null;
        if (!slot) return;
        const bar = slot.querySelector('[data-bar]');
        if (!bar) return;
        const h = bar.offsetHeight;
        if (slot._h !== h) { slot.style.minHeight = h + 'px'; slot._h = h; }
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const slotBottom = slot.getBoundingClientRect().bottom;
        const hostTop = this.getBoundingClientRect().top;
        const float = slotBottom > vh + 1 && hostTop < vh;
        bar.classList.toggle('is-floating', float);
      }

      next() { if (this.index < this.steps.length - 1) this.go(this.index + 1, { back: false }); }

      prev() {
        if (this.index <= 0) return;
        this.go(this.index - 1, { back: true, fromHistory: true });
        if (!this.useHistory) return;
        if (this.pushes > 0) {
          /* Keep the browser history in step without waiting for it to render */
          this.pushes--;
          this._ignorePop = true;
          clearTimeout(this._ignoreT);
          this._ignoreT = setTimeout(() => { this._ignorePop = false; }, 800);
          window.history.back();
        } else {
          this.replace(this.index);
        }
      }

      replace(i) {
        try { window.history.replaceState(Object.assign({}, window.history.state, { tccListicle: this.id_, tccStep: i }), ''); } catch (err) {}
      }

      goToBlock(id) {
        const i = this.steps.findIndex((s) => s.dataset.blockId === id);
        if (i < 0) return false;
        this.go(i);
        return true;
      }

      media(step, on) {
        const reduce = this.reduced();
        step.querySelectorAll('video').forEach((v) => {
          const gif = v.hasAttribute('data-gif');
          if (on && (v.hasAttribute('autoplay') || v.hasAttribute('data-autoplay')) && (gif || !reduce)) {
            this.vplay(v);
          } else if (!on) {
            v.pause();
          }
        });
      }

      vplay(v) {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        if (v.preload !== 'auto') v.preload = 'auto';
        const step = v.closest('[data-step]');
        const live = () => !step || !step.hidden;
        const go = () => {
          if (!live() || !v.paused) return;
          const p = v.play();
          if (p && p.catch) p.catch(() => this.vretry(v));
        };
        if (!v._tccWired) {
          v._tccWired = true;
          v.addEventListener('canplay', go);
          v.addEventListener('loadeddata', go);
        }
        if (v.readyState === 0) { try { v.load(); } catch (err) {} }
        go();
      }

      vretry(v) {
        if (this._vwait) { this._vwait.add(v); return; }
        this._vwait = new Set([v]);
        const kick = () => {
          const list = Array.from(this._vwait || []);
          this._vwait = null;
          ['touchstart', 'click', 'scroll', 'keydown'].forEach((t) => window.removeEventListener(t, kick, true));
          list.forEach((x) => { const st = x.closest('[data-step]'); if (!st || !st.hidden) { const p = x.play(); if (p && p.catch) p.catch(() => {}); } });
        };
        ['touchstart', 'click', 'scroll', 'keydown'].forEach((t) => window.addEventListener(t, kick, { capture: true, passive: true }));
      }

      warm(k) {
        const st = this.steps && this.steps[k];
        if (!st || st._warm) return;
        st._warm = true;
        st.querySelectorAll('img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; });
        st.querySelectorAll('video[data-autoplay]').forEach((v) => {
          if (v.preload === 'auto') return;
          v.preload = 'auto';
          try { v.load(); } catch (err) {}
        });
      }

      reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

      chrome() {
        const total = this.steps.length;
        const cur = this.index + 1;
        this.segs.forEach((s, k) => s.classList.toggle('is-done', k < cur));
        if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? cur / total : 0) + ')';
        if (this.progress) {
          this.progress.setAttribute('aria-valuenow', cur);
          this.progress.setAttribute('aria-valuetext', cur + ' / ' + total);
        }
        if (this.currentEl) {
          const pad = this.dataset.pad === 'true' && total < 100;
          this.currentEl.textContent = pad ? String(cur).padStart(2, '0') : String(cur);
        }
        this.dataset.step = cur;
        if (this.offerBar) {
          const st = this.steps[this.index];
          const timerOn = !!this.offerTimer && st.dataset.obTimer !== 'false';
          if (this.offerTimer) this.offerTimer.hidden = !timerOn;
          this.offerBar.hidden = st.dataset.ob === 'false' || !timerOn;
        }
      }

      track(step, i) {
        if (this.design) return;
        const detail = { section: this.id_, step: i + 1, total: this.steps.length, block_id: step.dataset.blockId, type: step.dataset.type };
        this.dispatchEvent(new CustomEvent('tcc:listicle:step', { bubbles: true, detail: detail }));
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'tcc_listicle_step', tcc_listicle: detail });
        }
      }

      /* ---------- Events ---------- */
      onClick(e) {
        if (e.target instanceof Element && e.target.closest('[data-pi-card],[data-pi-switch],[data-pi-mode]') && this.piClick(e.target)) return;
        const t = e.target instanceof Element
          ? e.target.closest('[data-next],[data-prev],[data-add],[data-tab],[data-drag-card],[data-rev],[data-drawer-open],[data-drawer-close],[data-offer-go],[data-lightbox-open],[data-lightbox-close]')
          : null;
        if (!t || t.disabled) return;
        if (t.hasAttribute('data-next')) this.next();
        else if (t.hasAttribute('data-prev')) this.prev();
        else if (t.hasAttribute('data-tab')) this.tabSet(t.closest('[data-tabs]'), t.dataset.tab);
        else if (t.hasAttribute('data-drag-card')) this.dragCard(t);
        else if (t.hasAttribute('data-rev')) this.revMove(t);
        else if (t.hasAttribute('data-drawer-open')) {
          const step = t.closest('[data-step]');
          const dr = step ? step.querySelector('[data-drawer]') : null;
          if (dr) { this._opener = t; this.openDrawer(dr); }
        } else if (t.hasAttribute('data-drawer-close')) this.closeDrawer(t.closest('[data-drawer]'));
        else if (t.hasAttribute('data-offer-go')) this.offerGo(t);
        else if (t.hasAttribute('data-lightbox-open')) this.lightboxOpen(t);
        else if (t.hasAttribute('data-lightbox-close')) this.lightboxClose();
        else this.add(t);
      }

      onChange(e) {
        if (!(e.target instanceof Element)) return;
        const sel = e.target.closest('[data-variant-select]');
        if (!sel) return;
        const o = sel.selectedOptions[0];
        const offer = sel.closest('[data-offer]');
        if (!o || !offer) return;
        const set = (q, val) => {
          const el = offer.querySelector(q);
          if (!el) return;
          el.textContent = val || '';
          el.hidden = !val;
        };
        set('[data-price]', o.dataset.price);
        set('[data-compare]', o.dataset.compare);
        set('[data-save]', o.dataset.save);
      }

      onInput(e) {
        const r = e.target instanceof Element ? e.target.closest('[data-drag-range]') : null;
        if (r) this.dragSet(r.closest('[data-drag]'), Number(r.value), true);
      }

      /* ---------- Swipe between steps ---------- */
      initSwipe() {
        if (this.dataset.swipe !== 'true') return;
        const body = this.querySelector('.tcc-listicle__body');
        if (!body) return;
        this._sw = null;
        body.addEventListener('touchstart', (e) => this.touchStart(e), { passive: true });
        body.addEventListener('touchmove', (e) => this.touchMove(e), { passive: false });
        body.addEventListener('touchend', (e) => this.touchEnd(e));
        body.addEventListener('touchcancel', () => this.swipeBack());
        this.tapZones = this.dataset.tapZones === 'true';
        body.addEventListener('pointerdown', (e) => this.swipeStart(e), { passive: true });
        body.addEventListener('pointermove', (e) => this.swipeMove(e), { passive: true });
        body.addEventListener('pointerup', (e) => this.swipeEnd(e));
        body.addEventListener('pointercancel', (e) => { if (this._sw && this._sw.id === e.pointerId) this.swipeBack(); });
        body.addEventListener('lostpointercapture', (e) => { if (this._sw && this._sw.id === e.pointerId) this.swipeBack(); });
        body.addEventListener('dragstart', (e) => { if (e.target instanceof Element && e.target.closest('img, a')) e.preventDefault(); });
        body.addEventListener('wheel', (e) => this.swipeWheel(e), { passive: false });
        this._swBody = body;
        this._onKey = (e) => this.swipeKey(e);
        window.addEventListener('keydown', this._onKey);
        this._onClickCap = (e) => {
          if (!this._suppress) return;
          e.preventDefault();
          e.stopPropagation();
          this._suppress = false;
        };
        this.addEventListener('click', this._onClickCap, true);
      }

      /* Touch: touch events (not pointer events) so a slightly diagonal swipe is never cancelled by the browser */
      touchStart(e) {
        if (this._swBusy || e.touches.length !== 1) { this._sw = null; return; }
        this.unlockIfIdle();
        if (this._sgCheck) this._sgCheck();
        if (!this._swHealthy()) this.swipeReset();
        const t = e.target instanceof Element ? e.target : null;
        if (!t || t.closest('video[controls]') || !this.swipeOk(t)) return;
        const p = e.touches[0];
        const vw = window.innerWidth || document.documentElement.clientWidth;
        if (p.clientX < 24 || p.clientX > vw - 24) return;
        const step = this.steps[this.index];
        const box = step ? step.querySelector('.tcc-listicle__container') : null;
        if (!box) return;
        this._sw = { id: 'touch', x: p.clientX, y: p.clientY, t: performance.now(), dx: 0, lock: '', edge: false, box: box, step: step, mouse: false, target: t };
      }

      touchMove(e) {
        const s = this._sw;
        if (!s || s.id !== 'touch') return;
        if (e.touches.length !== 1) { this.swipeBack(); return; }
        const p = e.touches[0];
        const dx = p.clientX - s.x;
        const dy = p.clientY - s.y;
        if (!s.lock) {
          const ax = Math.abs(dx);
          const ay = Math.abs(dy);
          if (ax < 12 && ay < 10) return;
          /* Vertical wins any tie: the page must always scroll. Only a clearly sideways move becomes a step swipe. */
          if (ay >= 10 && ay * 1.4 >= ax) { this._sw = null; return; }
          if (ax < 12 || ax < ay * 1.4) return;
          s.lock = 'x';
          this.swipeLock(s);
        }
        if (e.cancelable) e.preventDefault();
        this.swipeDrag(s, dx);
      }

      touchEnd(e) {
        const s = this._sw;
        if (!s || s.id !== 'touch') return;
        this._sw = null;
        if (s.lock === 'x') { this.swipeFinish(s); return; }
        if (s.lock || !this.tapZones) return;
        /* Story-style tap: right edge = next, left edge = back (only on non-interactive areas) */
        if (performance.now() - s.t > 350) return;
        const t = s.target;
        if (t && t.closest('a, button, input, select, textarea, label, summary, video, [role="button"], [role="switch"], [contenteditable], [data-bar], [data-drawer], [data-rev-track], [data-no-swipe]')) return;
        try { if (String(window.getSelection() || '').trim()) return; } catch (err) {}
        const vw = window.innerWidth || document.documentElement.clientWidth;
        if (s.x > vw * 0.75) { if (e.cancelable) e.preventDefault(); this.swipeGo(1); }
        else if (s.x < vw * 0.25) { if (e.cancelable) e.preventDefault(); this.swipeGo(-1); }
      }

      swipeLock(s) {
        s.step.classList.remove('is-entering', 'is-back');
        s.box.style.transition = 'none';
        s.box.style.willChange = 'transform, opacity';
      }

      swipeDrag(s, dx) {
        s.edge = (dx < 0 && this.index >= this.steps.length - 1) || (dx > 0 && this.index <= 0);
        s.dx = dx;
        const d = s.edge ? dx * 0.25 : dx;
        const w = s.box.offsetWidth || 1;
        s.box.style.transform = 'translate3d(' + d + 'px, 0, 0)';
        s.box.style.opacity = String(1 - Math.min(Math.abs(d) / w, 1) * 0.6);
      }

      swipeFinish(s) {
        this.classList.remove('is-swiping');
        this._suppress = true;
        setTimeout(() => { this._suppress = false; }, 400);
        const w = s.box.offsetWidth || window.innerWidth;
        const dist = Math.abs(s.dx);
        const speed = dist / Math.max(performance.now() - s.t, 1);
        const pass = !s.edge && (dist > Math.min(70, w * 0.18) || (dist > 25 && speed > 0.3));
        if (!pass) { this.swipeBack(s); return; }
        this.swipeGo(s.dx < 0 ? 1 : -1, s.box);
      }

      swipeStart(e) {
        if (!e.isPrimary || this._swBusy || e.pointerType === 'touch') return;
        const mouse = e.pointerType === 'mouse';
        if (mouse && e.button !== 0) return;
        const t = e.target instanceof Element ? e.target : null;
        if (!t || t.closest('video[controls]') || !this.swipeOk(t)) return;
        const vw = window.innerWidth || document.documentElement.clientWidth;
        if (!mouse && (e.clientX < 16 || e.clientX > vw - 16)) return;
        const step = this.steps[this.index];
        const box = step ? step.querySelector('.tcc-listicle__container') : null;
        if (!box) return;
        this._sw = { id: e.pointerId, x: e.clientX, y: e.clientY, t: performance.now(), dx: 0, lock: '', edge: false, box: box, step: step, mouse: mouse };
      }

      swipeMove(e) {
        const s = this._sw;
        if (!s || e.pointerId !== s.id) return;
        const dx = e.clientX - s.x;
        const dy = e.clientY - s.y;
        if (!s.lock) {
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          s.lock = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
          if (s.lock === 'y') { this._sw = null; return; }
          this.swipeLock(s);
          if (s.mouse) {
            try { this._swBody.setPointerCapture(s.id); } catch (err) {}
            try { window.getSelection().removeAllRanges(); } catch (err) {}
            this.classList.add('is-swiping');
          }
        }
        this.swipeDrag(s, dx);
      }

      swipeEnd(e) {
        const s = this._sw;
        if (!s || e.pointerId !== s.id) return;
        this._sw = null;
        if (s.lock !== 'x') return;
        this.swipeFinish(s);
      }

      swipeGo(dir, box) {
        if (dir > 0 ? this.index >= this.steps.length - 1 : this.index <= 0) return;
        const step = this.steps[this.index];
        box = box || (step ? step.querySelector('.tcc-listicle__container') : null);
        const from = this.index;
        const nav = () => {
          this._swBusy = false;
          if (dir > 0) this.next(); else this.prev();
          this._swTimer = setTimeout(() => { if (this.index === from) this.swipeReset(); }, 600);
        };
        if (!box || this.reduced()) { nav(); return; }
        const w = box.offsetWidth || window.innerWidth;
        this._swBusy = true;
        step.classList.remove('is-entering', 'is-back');
        box.style.transition = 'transform .18s ease-in, opacity .18s ease-in';
        box.style.transform = 'translate3d(' + (-dir * w * 0.6) + 'px, 0, 0)';
        box.style.opacity = '0';
        setTimeout(nav, 180);
      }

      swipeOk(t) {
        if (t instanceof Element && t.closest('input, select, textarea, [contenteditable], [data-bar], [data-rev-track], [data-drawer], [data-lightbox], [data-no-swipe]')) return false;
        if (this.lightbox && this.lightbox.open) return false;
        return !(this.drawers || []).some((d) => d.open);
      }

      /* Trackpad two-finger swipe (horizontal wheel) */
      swipeWheel(e) {
        if (e.ctrlKey || Math.abs(e.deltaX) <= Math.abs(e.deltaY) || !this.swipeOk(e.target)) return;
        e.preventDefault();
        clearTimeout(this._wlT);
        this._wlT = setTimeout(() => { this._wLock = false; this._wx = 0; }, 180);
        if (this._wLock || this._swBusy) return;
        this._wx = (this._wx || 0) + e.deltaX;
        if (Math.abs(this._wx) < 60) return;
        const dir = this._wx > 0 ? 1 : -1;
        this._wx = 0;
        this._wLock = true;
        this.swipeGo(dir);
      }

      /* Left / right arrow keys while the listicle is on screen */
      swipeKey(e) {
        if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        const a = document.activeElement;
        if (a && a !== document.body && !this.contains(a)) return;
        if (a && (a.closest('[role="tablist"], [role="radiogroup"]') || !this.swipeOk(a))) return;
        const r = this.getBoundingClientRect();
        if (r.bottom <= 0 || r.top >= (window.innerHeight || 0)) return;
        if (this._swBusy) return;
        e.preventDefault();
        this.swipeGo(e.key === 'ArrowRight' ? 1 : -1);
      }

      swipeBack(s) {
        s = s || this._sw;
        this._sw = null;
        this.classList.remove('is-swiping');
        if (!s || s.lock !== 'x') return;
        const box = s.box;
        box.style.transition = 'transform .25s ease, opacity .25s ease';
        box.style.transform = '';
        box.style.opacity = '';
        setTimeout(() => { box.style.transition = ''; box.style.willChange = ''; }, 260);
      }

      /* ---------- Page scroll guard ----------
         Apps and theme scripts (Klaviyo forms, newsletter popups, cart drawers) lock page scroll on
         <html>/<body> when they open, and some treat each step change (history.pushState) as a new page
         view. When their popup is hidden (Hide Klaviyo popups) or never visible, that lock stays and
         the page stops scrolling. This re-enables scrolling whenever nothing modal is actually on screen. */
      initScrollGuard() {
        if (!window.MutationObserver || !document.body) return;
        this._sgCheck = () => {
          if (this._sgRaf) return;
          this._sgRaf = requestAnimationFrame(() => { this._sgRaf = null; this.scrollGuard(); });
        };
        this._sgMo = new MutationObserver(this._sgCheck);
        const opts = { attributes: true, attributeFilter: ['class', 'style'] };
        this._sgMo.observe(document.documentElement, opts);
        this._sgMo.observe(document.body, opts);
        this._sgCheck();
      }

      scrollGuard() {
        const html = document.documentElement;
        const body = document.body;
        if (!body) return;
        const unlocked = html.classList.contains('tcc-listicle-unlock');
        if (this.modalOnScreen()) {
          if (unlocked) html.classList.remove('tcc-listicle-unlock');
          return;
        }
        if (unlocked) return;
        const hs = getComputedStyle(html);
        const bs = getComputedStyle(body);
        const locked = hs.overflowY === 'hidden' || hs.overflowY === 'clip' || bs.overflowY === 'hidden' || bs.overflowY === 'clip' ||
          bs.position === 'fixed' || hs.touchAction === 'none' || bs.touchAction === 'none';
        if (locked) html.classList.add('tcc-listicle-unlock');
      }

      /* A dialog or drawer that is actually visible on screen (ours or anyone else's) */
      modalOnScreen() {
        if ((this.drawers || []).some((d) => d.open) || (this.lightbox && this.lightbox.open)) return true;
        const vw = window.innerWidth || 0;
        const vh = window.innerHeight || 0;
        return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"]')).some((el) => {
          if (this.contains(el)) return false;
          const r = el.getBoundingClientRect();
          if (r.width < 2 || r.height < 2 || r.right <= 0 || r.bottom <= 0 || r.left >= vw || r.top >= vh) return false;
          const cs = getComputedStyle(el);
          return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.05;
        });
      }

      /* True when no step is left shifted or faded by an interrupted swipe */
      _swHealthy() {
        return this.steps.every((st) => {
          const b = st.querySelector('.tcc-listicle__container');
          return !b || (!b.style.transform && !b.style.opacity);
        });
      }

      swipeReset() {
        this.steps.forEach((st) => {
          const b = st.querySelector('.tcc-listicle__container');
          if (!b) return;
          b.style.transition = '';
          b.style.transform = '';
          b.style.opacity = '';
          b.style.willChange = '';
        });
      }

      /* Bar product widget: jump to the offer step and open its drawer */
      offerGo(btn) {
        let i = this.steps.findIndex((s) => s.querySelector('[data-drawer]'));
        if (i < 0) i = this.steps.findIndex((s) => s.dataset.type === 'final');
        if (i < 0) i = this.steps.length - 1;
        const moved = i !== this.index;
        if (moved) this.go(i, { back: i < this.index });
        const dr = this.steps[i].querySelector('[data-drawer]');
        if (!dr) return;
        this._opener = moved ? null : btn;
        setTimeout(() => this.openDrawer(dr), moved && !this.reduced() ? 350 : 0);
      }

      /* ---------- Review photo popup ---------- */
      lightboxOpen(btn) {
        const lb = this.lightbox;
        if (!lb || lb.open) return;
        const img = lb.querySelector('[data-lightbox-img]');
        if (img) {
          if (btn.dataset.w) img.width = Number(btn.dataset.w);
          if (btn.dataset.h) img.height = Number(btn.dataset.h);
          img.src = btn.dataset.src || '';
          img.alt = btn.dataset.alt || '';
        }
        this._lbFocus = btn;
        try { lb.showModal(); } catch (err) { lb.setAttribute('open', ''); }
        document.documentElement.classList.add('tcc-listicle-lock');
      }

      lightboxClose() {
        const lb = this.lightbox;
        if (!lb || !lb.open) return;
        try { lb.close(); } catch (err) { lb.removeAttribute('open'); }
        if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('tcc-listicle-lock');
        const img = lb.querySelector('[data-lightbox-img]');
        if (img) img.src = 'data:,';
        if (this._lbFocus && this.contains(this._lbFocus)) this._lbFocus.focus({ preventScroll: true });
        this._lbFocus = null;
      }

      /* ---------- Step Tabs ---------- */
      tabSet(tabs, n) {
        if (!tabs) return;
        tabs.querySelectorAll('[data-tab]').forEach((b) => {
          const on = b.dataset.tab === n;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        tabs.querySelectorAll('[data-tile]').forEach((t) => {
          t.classList.toggle('is-on', (t.dataset.on || '').split(',').indexOf(n) > -1);
        });
        tabs.querySelectorAll('[data-caption]').forEach((c) => { c.hidden = c.dataset.caption !== n; });
      }

      /* ---------- Step Drag ---------- */
      dragSet(drag, val, user) {
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        if (!range) return;
        const min = Number(range.min) || 0;
        const max = Number(range.max) || 0;
        val = Math.min(Math.max(Math.round(val), min), max);
        range.value = val;
        range.style.setProperty('--p', (max > min ? ((val - min) / (max - min)) * 100 : 0) + '%');
        const unit = drag.dataset.unit || '';
        range.setAttribute('aria-valuetext', val + unit);
        const out = drag.querySelector('[data-drag-value]');
        if (out) out.textContent = val + unit;

        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const card = cards.find((c) => c.dataset.max === '' || val <= Number(c.dataset.max)) || cards[cards.length - 1];
        cards.forEach((c) => {
          const on = c === card;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (!card) return;
        const n = parseInt(card.dataset.amount, 10) || 0;
        drag.querySelectorAll('[data-drag-icon]').forEach((ic, k) => { ic.hidden = k >= n; });
        const amt = drag.querySelector('[data-drag-amount]');
        if (amt) amt.textContent = n + ' ' + (n === 1 ? drag.dataset.one : drag.dataset.many);
        if (user) this.picked = card.dataset.name || '';
      }

      dragCard(card) {
        const drag = card.closest('[data-drag]');
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const k = cards.indexOf(card);
        let val;
        if (card.dataset.max !== '') val = Number(card.dataset.max);
        else if (k > 0 && cards[k - 1].dataset.max !== '') val = Number(cards[k - 1].dataset.max) + 1;
        else val = range ? Number(range.max) : 0;
        this.dragSet(drag, val, true);
      }

      /* ---------- Reviews slider ---------- */
      revMove(btn) {
        const wrap = btn.closest('[data-revs]');
        const track = wrap ? wrap.querySelector('[data-rev-track]') : null;
        if (!track) return;
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: step * Number(btn.dataset.rev), behavior: this.reduced() ? 'auto' : 'smooth' });
      }

      revArrows(wrap) {
        if (!wrap) return;
        const track = wrap.querySelector('[data-rev-track]');
        const arrows = wrap.querySelector('[data-rev-arrows]');
        if (!track || !arrows) return;
        const max = track.scrollWidth - track.clientWidth;
        arrows.hidden = max <= 2;
        const [prev, next] = arrows.querySelectorAll('[data-rev]');
        const x = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
      }

      /* ---------- Offer drawer: size cards + subscribe / buy once ---------- */
      initDrawers() {
        this.drawers = Array.from(this.querySelectorAll('[data-drawer]'));
        this.drawers.forEach((d) => {
          d.addEventListener('cancel', (e) => { e.preventDefault(); this.closeDrawer(d); });
          d.addEventListener('click', (e) => { if (e.target === d) this.closeDrawer(d); });
          const cards = Array.from(d.querySelectorAll('[data-pi-card]'));
          const act = cards.findIndex((c) => c.classList.contains('is-active'));
          d._i = act > -1 ? act : 0;
          d._wantSub = d.dataset.defaultSub === 'true';
          this.piRender(d);
        });
      }

      piClick(t) {
        const dr = t.closest('[data-drawer]');
        if (!dr) return false;
        const card = t.closest('[data-pi-card]');
        if (card) {
          if (card.disabled) return true;
          dr._i = Array.from(dr.querySelectorAll('[data-pi-card]')).indexOf(card);
          this.piRender(dr);
          return true;
        }
        const sw = dr.querySelector('[data-pi-switch]');
        const canToggle = sw && !sw.disabled;
        if (t.closest('[data-pi-switch]')) {
          if (canToggle) { dr._wantSub = !dr._sub; this.piRender(dr); }
          return true;
        }
        const mode = t.closest('[data-pi-mode]');
        if (mode) {
          if (canToggle) { dr._wantSub = mode.dataset.piMode === 'sub'; this.piRender(dr); }
          return true;
        }
        return false;
      }

      piRender(dr) {
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const i = dr._i || 0;
        cards.forEach((c, k) => {
          const on = k === i;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        dr.querySelectorAll('[data-pi-panel]').forEach((p) => { p.hidden = Number(p.dataset.piPanel) !== i; });

        const card = cards[i];
        const atc = dr.querySelector('[data-drawer-atc]');
        if (!card) {
          /* Single product without size cards: keep the server-rendered state, only sync the toggle */
          this.piMode(dr, dr.dataset.plan || '', atc);
          return;
        }
        const plan = card.dataset.planId || '';
        this.piMode(dr, plan, atc);
        dr.querySelectorAll('[data-pi-percent]').forEach((el) => { el.textContent = card.dataset.percent || '0'; });
        dr.querySelectorAll('[data-pi-after-percent]').forEach((el) => { el.textContent = card.dataset.afterPercent || '0'; });
        if (atc) {
          const ok = !!card.dataset.variantId && card.dataset.available === 'true';
          atc.dataset.variant = ok ? card.dataset.variantId : '';
          atc.disabled = !ok;
          atc.dataset.plan = dr._sub ? plan : '';
        }
        const err = dr.querySelector('[data-error]');
        if (err) err.hidden = true;
      }

      piMode(dr, plan, atc) {
        const hasPlan = plan !== '';
        const requires = dr.dataset.requiresPlan === 'true';
        dr._sub = hasPlan && (requires || dr._wantSub);
        dr.classList.toggle('tcc-listicle__pi--sub', dr._sub);
        dr.classList.toggle('tcc-listicle__pi--once', !dr._sub);
        dr.classList.toggle('tcc-listicle__pi--no-plan', !hasPlan);
        const sw = dr.querySelector('[data-pi-switch]');
        if (sw) {
          sw.setAttribute('aria-checked', String(dr._sub));
          sw.disabled = !hasPlan || requires;
        }
        if (atc) atc.dataset.plan = dr._sub ? plan : '';
      }

      piPick(dr, name) {
        const want = String(name || '').trim().toLowerCase();
        if (!want) return;
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const k = cards.findIndex((c) => {
          const n = (c.dataset.name || '').trim().toLowerCase();
          return n === want || n.indexOf(want + ' ') === 0 || want.indexOf(n + ' ') === 0;
        });
        if (k > -1 && !cards[k].disabled) { dr._i = k; this.piRender(dr); }
      }

      openDrawer(dr) {
        if (!dr || dr.open) return;
        if (this.picked && dr._picked !== this.picked) {
          dr._picked = this.picked;
          this.piPick(dr, this.picked);
        }
        this._lastFocus = this._opener || document.activeElement;
        this._opener = null;
        try { dr.showModal(); } catch (err) { dr.setAttribute('open', ''); }
        document.documentElement.classList.add('tcc-listicle-lock');
        requestAnimationFrame(() => requestAnimationFrame(() => dr.classList.add('is-open')));
        if (!this.design) this.dispatchEvent(new CustomEvent('tcc:listicle:drawer', { bubbles: true, detail: { section: this.id_, open: true } }));
      }

      closeDrawer(dr, instant) {
        if (!dr || !dr.open) return;
        dr.classList.remove('is-open');
        const done = () => {
          try { dr.close(); } catch (err) { dr.removeAttribute('open'); }
          if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('tcc-listicle-lock');
          const f = this._lastFocus;
          this._lastFocus = null;
          if (!instant && f && typeof f.focus === 'function' && this.contains(f)) f.focus({ preventScroll: true });
        };
        if (instant || this.reduced()) done();
        else setTimeout(done, 320);
      }

      /* ---------- Cart ---------- */
      async add(btn) {
        const step = btn.closest('[data-step]');
        let id = btn.dataset.variant;
        if (btn.hasAttribute('data-use-select') && step) {
          const sel = step.querySelector('[data-variant-select]');
          if (sel && sel.value) id = sel.value;
        }
        if (!id) return;
        const scope = btn.closest('[data-drawer]') || btn.closest('[data-offer]') || btn.closest('[data-bar]') || step;
        const err = (scope && scope.querySelector('[data-error]')) || (step && step.querySelector('[data-error]'));
        btn.disabled = true;
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        try {
          const r = await fetch(this.dataset.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [(() => {
              const it = { id: Number(id), quantity: 1 };
              if (btn.dataset.plan) it.selling_plan = Number(btn.dataset.plan);
              return it;
            })()] })
          });
          if (!r.ok) throw new Error('add');
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          let target = btn.dataset.action === 'checkout' ? root + '/checkout' : this.dataset.cartUrl;
          const code = step ? (step.dataset.discount || '').trim() : '';
          if (code) target = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
          window.location.href = target;
        } catch (e) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (err) err.hidden = false;
          this.dock();
        }
      }

      /* ---------- Date + timer ---------- */
      initDates() {
        const lang = document.documentElement.lang || undefined;
        let today = '';
        try { today = new Date().toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (err) { return; }
        this.querySelectorAll('[data-date]').forEach((el) => {
          el.textContent = el.dataset.date.replace(/\{today\}/g, today);
        });
      }

      initTimer() {
        const els = Array.from(this.querySelectorAll('[data-timer-value]'));
        if (!els.length) return;
        const dur = Math.max(1, parseFloat(this.dataset.timerMinutes) || 15) * 60000;
        const restart = this.dataset.timerRestart === 'true';
        const key = 'tcc-listicle-timer-' + this.id_;
        const save = (v) => { try { sessionStorage.setItem(key, String(v)); } catch (err) {} };
        let end = 0;
        try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (err) {}
        if (!end || (end <= Date.now() && restart)) { end = Date.now() + dur; save(end); }
        const two = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let left = end - Date.now();
          if (left <= 0) {
            if (restart) { end = Date.now() + dur; save(end); left = dur; }
            else left = 0;
          }
          const sec = Math.ceil(left / 1000);
          const h = Math.floor(sec / 3600);
          const m = Math.floor((sec % 3600) / 60);
          const sc = sec % 60;
          const txt = two(h) + ':' + two(m) + ':' + two(sc);
          const lbl = two(h) + 'h : ' + two(m) + 'm : ' + two(sc) + 's';
          els.forEach((el) => { el.textContent = el.dataset.format === 'labels' ? lbl : txt; });
          if (!left && this.timerId) clearInterval(this.timerId);
        };
        tick();
        this.timerId = setInterval(tick, 1000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-interactive-vertical"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-vertical')) {
    customElements.define('tcc-vertical', class TccVertical extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.id_ = this.dataset.sectionId;
        this.design = this.dataset.design === 'true';
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.picked = '';

        this._onClick = this.onClick.bind(this);
        this._onChange = this.onChange.bind(this);
        this._onInput = this.onInput.bind(this);
        this._onShow = () => {
          this.querySelectorAll('.is-loading').forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
          this.unlockIfIdle();
        };
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
        this.addEventListener('input', this._onInput);
        window.addEventListener('pageshow', this._onShow);

        this.initDates();
        this.initSigns();
        this.initTimer();
        this.initDrawers();
        this.lightbox = this.querySelector('[data-lightbox]');
        if (this.lightbox) {
          this.lightbox.addEventListener('cancel', (e) => { e.preventDefault(); this.lightboxClose(); });
          this.lightbox.addEventListener('click', (e) => { if (e.target === this.lightbox) this.lightboxClose(); });
        }
        this.initScrollGuard();
        this.initBar();
        this.querySelectorAll('[data-revs]').forEach((w) => {
          const t = w.querySelector('[data-rev-track]');
          if (t) t.addEventListener('scroll', () => this.revArrows(w), { passive: true });
          this.revArrows(w);
        });

        if (this.design) {
          const pv = this.querySelector('[data-drawer][data-preview]');
          if (pv) this.openDrawer(pv);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('input', this._onInput);
        window.removeEventListener('pageshow', this._onShow);
        if (this._onBarScroll) {
          window.removeEventListener('scroll', this._onBarScroll);
          window.removeEventListener('resize', this._onBarScroll);
        }
        if (this._barRaf) cancelAnimationFrame(this._barRaf);
        if (this._io) this._io.disconnect();
        if (this.timerId) clearInterval(this.timerId);
        if (this._sgMo) this._sgMo.disconnect();
        if (this._sgRaf) cancelAnimationFrame(this._sgRaf);
        this._sgRaf = null;
        (this.drawers || []).forEach((d) => { try { if (d.open) d.close(); } catch (err) {} });
        if (this.lightbox && this.lightbox.open) { try { this.lightbox.close(); } catch (err) {} }
        document.documentElement.classList.remove('tcc-vertical-lock', 'tcc-vertical-unlock');
        this._ready = false;
      }

      /* ---------- Events ---------- */
      onClick(e) {
        if (e.target instanceof Element && e.target.closest('[data-pi-card],[data-pi-switch],[data-pi-mode]') && this.piClick(e.target)) return;
        const t = e.target instanceof Element
          ? e.target.closest('[data-add],[data-drag-card],[data-rev],[data-drawer-open],[data-drawer-go],[data-drawer-close],[data-scroll-next],[data-scroll-offer],[data-lightbox-open],[data-lightbox-close]')
          : null;
        if (!t || t.disabled) return;
        if (t.hasAttribute('data-drag-card')) this.dragCard(t);
        else if (t.hasAttribute('data-rev')) this.revMove(t);
        else if (t.hasAttribute('data-drawer-open')) {
          const step = t.closest('[data-step]');
          const dr = step ? step.querySelector('[data-drawer]') : null;
          if (dr) { this._opener = t; this.openDrawer(dr); }
        } else if (t.hasAttribute('data-drawer-go')) this.drawerGo(t);
        else if (t.hasAttribute('data-drawer-close')) this.closeDrawer(t.closest('[data-drawer]'));
        else if (t.hasAttribute('data-scroll-next')) this.scrollNext(t);
        else if (t.hasAttribute('data-scroll-offer')) this.scrollOffer();
        else if (t.hasAttribute('data-lightbox-open')) this.lightboxOpen(t);
        else if (t.hasAttribute('data-lightbox-close')) this.lightboxClose();
        else this.add(t);
      }

      /* ---------- Scrolling between blocks ---------- */
      stickyOffset() {
        const a = this.querySelector('[data-announce]');
        let h = 0;
        if (a && getComputedStyle(a).position === 'sticky') h += a.offsetHeight + (parseFloat(getComputedStyle(a).top) || 0);
        return h;
      }

      scrollToEl(el) {
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.scrollY - this.stickyOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: this.reduced() ? 'auto' : 'smooth' });
      }

      scrollNext(btn) {
        const step = btn.closest('[data-step]');
        const i = this.steps.indexOf(step);
        this.scrollToEl(this.steps[i + 1]);
      }

      offerTarget() {
        return this.querySelector('[data-fin]') || this.querySelector('[data-step][data-type="final"]') || this.querySelector('[data-offer]');
      }

      scrollOffer() { this.scrollToEl(this.offerTarget()); }

      /* Open the offer drawer from anywhere on the page; scroll to the offer when there is no drawer */
      drawerGo(btn) {
        const dr = this.querySelector('[data-drawer]');
        if (!dr) { this.scrollOffer(); return; }
        this._opener = btn;
        this.openDrawer(dr);
        this.barUpdate();
      }

      /* ---------- Sticky CTA bar ---------- */
      initBar() {
        this.bar = this.querySelector('[data-vbar]');
        if (!this.bar || this.bar.hasAttribute('data-preview')) return;
        this._offerOn = false;
        const targets = Array.from(this.querySelectorAll('[data-fin], [data-offer]'));
        if (this.bar.dataset.hideOffer === 'true' && targets.length && window.IntersectionObserver) {
          this._io = new IntersectionObserver((entries) => {
            entries.forEach((en) => { en.target._tccVis = en.isIntersecting; });
            this._offerOn = targets.some((el) => el._tccVis);
            this.barUpdate();
          }, { threshold: 0.2 });
          targets.forEach((el) => this._io.observe(el));
        }
        this._trig = this.bar.dataset.trigger || 'scroll';
        this._trigEl = this.barTriggerEl();
        this._onBarScroll = () => {
          if (this._barRaf) return;
          this._barRaf = requestAnimationFrame(() => { this._barRaf = null; this.barUpdate(); });
        };
        window.addEventListener('scroll', this._onBarScroll, { passive: true });
        window.addEventListener('resize', this._onBarScroll);
        this.barUpdate();
      }

      /* Element the bar waits for: a block of this listicle, or any element on the page by CSS selector */
      barTriggerEl() {
        const bar = this.bar;
        if (!bar) return null;
        if (this._trig === 'block') {
          const n = parseInt(bar.dataset.afterBlock, 10) || 0;
          return n > 0 ? (this.steps[Math.min(n, this.steps.length) - 1] || null) : null;
        }
        if (this._trig === 'selector') {
          const sel = (bar.dataset.afterSelector || '').trim();
          if (!sel) return null;
          try { return document.querySelector(sel); } catch (err) { return null; }
        }
        return null;
      }

      barUpdate() {
        const bar = this.bar;
        if (!bar || bar.hasAttribute('data-preview')) return;
        const r = this.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const after = parseFloat(bar.dataset.after) || 0;
        const drawerOpen = (this.drawers || []).some((d) => d.open);
        if (this._trig !== 'scroll' && (!this._trigEl || !this._trigEl.isConnected)) this._trigEl = this.barTriggerEl();
        let passed;
        if (this._trigEl) {
          const tr = this._trigEl.getBoundingClientRect();
          passed = (bar.dataset.afterPoint === 'bottom' ? tr.bottom : tr.top) <= 0;
        } else {
          passed = -r.top >= after;
        }
        const show = passed && r.bottom > vh && !this._offerOn && !drawerOpen;
        if (bar.classList.contains('is-visible') === show) return;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
      }

      onChange(e) {
        if (!(e.target instanceof Element)) return;
        if (e.target.matches('[data-sign-check]')) { this.signUpdate(true); return; }
        const sel = e.target.closest('[data-variant-select]');
        if (!sel) return;
        const o = sel.selectedOptions[0];
        const offer = sel.closest('[data-offer]');
        if (!o || !offer) return;
        const set = (q, val) => {
          const el = offer.querySelector(q);
          if (!el) return;
          el.textContent = val || '';
          el.hidden = !val;
        };
        set('[data-price]', o.dataset.price);
        set('[data-compare]', o.dataset.compare);
        set('[data-save]', o.dataset.save);
      }

      onInput(e) {
        const r = e.target instanceof Element ? e.target.closest('[data-drag-range]') : null;
        if (r) this.dragSet(r.closest('[data-drag]'), Number(r.value), true);
      }

      dragSet(drag, val, user) {
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        if (!range) return;
        const min = Number(range.min) || 0;
        const max = Number(range.max) || 0;
        val = Math.min(Math.max(Math.round(val), min), max);
        range.value = val;
        range.style.setProperty('--p', (max > min ? ((val - min) / (max - min)) * 100 : 0) + '%');
        const unit = drag.dataset.unit || '';
        range.setAttribute('aria-valuetext', val + unit);
        const out = drag.querySelector('[data-drag-value]');
        if (out) out.textContent = val + unit;

        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const card = cards.find((c) => c.dataset.max === '' || val <= Number(c.dataset.max)) || cards[cards.length - 1];
        cards.forEach((c) => {
          const on = c === card;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (!card) return;
        const n = parseInt(card.dataset.amount, 10) || 0;
        const per = Math.max(1, parseFloat(drag.dataset.per) || 1);
        const icons = Math.min(20, Math.ceil(n / per));
        drag.querySelectorAll('[data-drag-icon]').forEach((ic, k) => { ic.hidden = k >= icons; });
        const amt = drag.querySelector('[data-drag-amount]');
        if (amt) amt.textContent = n + ' ' + (n === 1 ? drag.dataset.one : drag.dataset.many);
        if (user) this.picked = card.dataset.name || '';
      }

      dragCard(card) {
        const drag = card.closest('[data-drag]');
        if (!drag) return;
        const range = drag.querySelector('[data-drag-range]');
        const cards = Array.from(drag.querySelectorAll('[data-drag-card]'));
        const k = cards.indexOf(card);
        let val;
        if (card.dataset.max !== '') val = Number(card.dataset.max);
        else if (k > 0 && cards[k - 1].dataset.max !== '') val = Number(cards[k - 1].dataset.max) + 1;
        else val = range ? Number(range.max) : 0;
        this.dragSet(drag, val, true);
      }

      revMove(btn) {
        const wrap = btn.closest('[data-revs]');
        const track = wrap ? wrap.querySelector('[data-rev-track]') : null;
        if (!track) return;
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: step * Number(btn.dataset.rev), behavior: this.reduced() ? 'auto' : 'smooth' });
      }

      revArrows(wrap) {
        if (!wrap) return;
        const track = wrap.querySelector('[data-rev-track]');
        const arrows = wrap.querySelector('[data-rev-arrows]');
        if (!track || !arrows) return;
        const max = track.scrollWidth - track.clientWidth;
        arrows.hidden = max <= 2;
        const [prev, next] = arrows.querySelectorAll('[data-rev]');
        const x = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
      }

      initDrawers() {
        this.drawers = Array.from(this.querySelectorAll('[data-drawer]'));
        this.drawers.forEach((d) => {
          d.addEventListener('cancel', (e) => { e.preventDefault(); this.closeDrawer(d); });
          d.addEventListener('click', (e) => { if (e.target === d) this.closeDrawer(d); });
          const cards = Array.from(d.querySelectorAll('[data-pi-card]'));
          const act = cards.findIndex((c) => c.classList.contains('is-active'));
          d._i = act > -1 ? act : 0;
          d._wantSub = d.dataset.defaultSub === 'true';
          this.piRender(d);
        });
      }

      piClick(t) {
        const dr = t.closest('[data-drawer]');
        if (!dr) return false;
        const card = t.closest('[data-pi-card]');
        if (card) {
          if (card.disabled) return true;
          dr._i = Array.from(dr.querySelectorAll('[data-pi-card]')).indexOf(card);
          this.piRender(dr);
          return true;
        }
        const sw = dr.querySelector('[data-pi-switch]');
        const canToggle = sw && !sw.disabled;
        if (t.closest('[data-pi-switch]')) {
          if (canToggle) { dr._wantSub = !dr._sub; this.piRender(dr); }
          return true;
        }
        const mode = t.closest('[data-pi-mode]');
        if (mode) {
          if (canToggle) { dr._wantSub = mode.dataset.piMode === 'sub'; this.piRender(dr); }
          return true;
        }
        return false;
      }

      piRender(dr) {
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const i = dr._i || 0;
        cards.forEach((c, k) => {
          const on = k === i;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        dr.querySelectorAll('[data-pi-panel]').forEach((p) => { p.hidden = Number(p.dataset.piPanel) !== i; });

        const card = cards[i];
        const atc = dr.querySelector('[data-drawer-atc]');
        if (!card) {
          /* Single product without size cards: keep the server-rendered state, only sync the toggle */
          this.piMode(dr, dr.dataset.plan || '', atc);
          return;
        }
        const plan = card.dataset.planId || '';
        this.piMode(dr, plan, atc);
        dr.querySelectorAll('[data-pi-percent]').forEach((el) => { el.textContent = card.dataset.percent || '0'; });
        dr.querySelectorAll('[data-pi-after-percent]').forEach((el) => { el.textContent = card.dataset.afterPercent || '0'; });
        if (atc) {
          const ok = !!card.dataset.variantId && card.dataset.available === 'true';
          atc.dataset.variant = ok ? card.dataset.variantId : '';
          atc.disabled = !ok;
          atc.dataset.plan = dr._sub ? plan : '';
        }
        const err = dr.querySelector('[data-error]');
        if (err) err.hidden = true;
      }

      piMode(dr, plan, atc) {
        const hasPlan = plan !== '';
        const requires = dr.dataset.requiresPlan === 'true';
        dr._sub = hasPlan && (requires || dr._wantSub);
        dr.classList.toggle('tcc-vertical__pi--sub', dr._sub);
        dr.classList.toggle('tcc-vertical__pi--once', !dr._sub);
        dr.classList.toggle('tcc-vertical__pi--no-plan', !hasPlan);
        const sw = dr.querySelector('[data-pi-switch]');
        if (sw) {
          sw.setAttribute('aria-checked', String(dr._sub));
          sw.disabled = !hasPlan || requires;
        }
        if (atc) atc.dataset.plan = dr._sub ? plan : '';
      }

      piPick(dr, name) {
        const want = String(name || '').trim().toLowerCase();
        if (!want) return;
        const cards = Array.from(dr.querySelectorAll('[data-pi-card]'));
        const k = cards.findIndex((c) => {
          const n = (c.dataset.name || '').trim().toLowerCase();
          return n === want || n.indexOf(want + ' ') === 0 || want.indexOf(n + ' ') === 0;
        });
        if (k > -1 && !cards[k].disabled) { dr._i = k; this.piRender(dr); }
      }

      openDrawer(dr) {
        if (!dr || dr.open) return;
        if (this.picked && dr._picked !== this.picked) {
          dr._picked = this.picked;
          this.piPick(dr, this.picked);
        }
        this._lastFocus = this._opener || document.activeElement;
        this._opener = null;
        try { dr.showModal(); } catch (err) { dr.setAttribute('open', ''); }
        document.documentElement.classList.add('tcc-vertical-lock');
        requestAnimationFrame(() => requestAnimationFrame(() => dr.classList.add('is-open')));
        if (this.bar) this.barUpdate();
        if (!this.design) this.dispatchEvent(new CustomEvent('tcc:vertical:drawer', { bubbles: true, detail: { section: this.id_, open: true } }));
      }

      closeDrawer(dr, instant) {
        if (!dr || !dr.open) return;
        dr.classList.remove('is-open');
        const done = () => {
          try { dr.close(); } catch (err) { dr.removeAttribute('open'); }
          if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('tcc-vertical-lock');
          const f = this._lastFocus;
          this._lastFocus = null;
          if (!instant && f && typeof f.focus === 'function' && this.contains(f)) f.focus({ preventScroll: true });
          this.barUpdate();
        };
        if (instant || this.reduced()) done();
        else setTimeout(done, 320);
      }

      async add(btn) {
        const step = btn.closest('[data-step]');
        let id = btn.dataset.variant;
        if (btn.hasAttribute('data-use-select') && step) {
          const sel = step.querySelector('[data-variant-select]');
          if (sel && sel.value) id = sel.value;
        }
        if (!id) return;
        const scope = btn.closest('[data-drawer]') || btn.closest('[data-offer]') || btn.parentElement || step;
        const err = (scope && scope.querySelector('[data-error]')) || (step && step.querySelector('[data-error]'));
        btn.disabled = true;
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        try {
          const r = await fetch(this.dataset.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [(() => {
              const it = { id: Number(id), quantity: 1 };
              if (btn.dataset.plan) it.selling_plan = Number(btn.dataset.plan);
              return it;
            })()] })
          });
          if (!r.ok) throw new Error('add');
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          let target = btn.dataset.action === 'checkout' ? root + '/checkout' : this.dataset.cartUrl;
          const code = step ? (step.dataset.discount || '').trim() : '';
          if (code) target = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
          window.location.href = target;
        } catch (e) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (err) err.hidden = false;
        }
      }

      initDates() {
        const lang = document.documentElement.lang || undefined;
        let today = '';
        try { today = new Date().toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (err) { return; }
        this.querySelectorAll('[data-date]').forEach((el) => {
          el.textContent = el.dataset.date.replace(/\{today\}/g, today);
        });
      }

      initTimer() {
        const els = Array.from(this.querySelectorAll('[data-timer-value]'));
        if (!els.length) return;
        const dur = Math.max(1, parseFloat(this.dataset.timerMinutes) || 15) * 60000;
        const restart = this.dataset.timerRestart === 'true';
        const key = 'tcc-vertical-timer-' + this.id_;
        const save = (v) => { try { sessionStorage.setItem(key, String(v)); } catch (err) {} };
        let end = 0;
        try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (err) {}
        if (!end || (end <= Date.now() && restart)) { end = Date.now() + dur; save(end); }
        const two = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let left = end - Date.now();
          if (left <= 0) {
            if (restart) { end = Date.now() + dur; save(end); left = dur; }
            else left = 0;
          }
          const sec = Math.ceil(left / 1000);
          const h = Math.floor(sec / 3600);
          const m = Math.floor((sec % 3600) / 60);
          const sc = sec % 60;
          const txt = two(h) + ':' + two(m) + ':' + two(sc);
          const lbl = two(h) + 'h : ' + two(m) + 'm : ' + two(sc) + 's';
          els.forEach((el) => { el.textContent = el.dataset.format === 'labels' ? lbl : txt; });
          if (!left && this.timerId) clearInterval(this.timerId);
        };
        tick();
        this.timerId = setInterval(tick, 1000);
      }

      lightboxOpen(btn) {
        const lb = this.lightbox;
        if (!lb || lb.open) return;
        const img = lb.querySelector('[data-lightbox-img]');
        if (img) {
          if (btn.dataset.w) img.width = Number(btn.dataset.w);
          if (btn.dataset.h) img.height = Number(btn.dataset.h);
          img.src = btn.dataset.src || '';
          img.alt = btn.dataset.alt || '';
        }
        this._lbFocus = btn;
        try { lb.showModal(); } catch (err) { lb.setAttribute('open', ''); }
        document.documentElement.classList.add('tcc-vertical-lock');
      }

      lightboxClose() {
        const lb = this.lightbox;
        if (!lb || !lb.open) return;
        try { lb.close(); } catch (err) { lb.removeAttribute('open'); }
        if (!(this.drawers || []).some((d) => d.open)) document.documentElement.classList.remove('tcc-vertical-lock');
        const img = lb.querySelector('[data-lightbox-img]');
        if (img) img.src = 'data:,';
        if (this._lbFocus && this.contains(this._lbFocus)) this._lbFocus.focus({ preventScroll: true });
        this._lbFocus = null;
      }

      initScrollGuard() {
        if (!window.MutationObserver || !document.body) return;
        this._sgCheck = () => {
          if (this._sgRaf) return;
          this._sgRaf = requestAnimationFrame(() => { this._sgRaf = null; this.scrollGuard(); });
        };
        this._sgMo = new MutationObserver(this._sgCheck);
        const opts = { attributes: true, attributeFilter: ['class', 'style'] };
        this._sgMo.observe(document.documentElement, opts);
        this._sgMo.observe(document.body, opts);
        this._sgCheck();
      }

      scrollGuard() {
        const html = document.documentElement;
        const body = document.body;
        if (!body) return;
        const unlocked = html.classList.contains('tcc-vertical-unlock');
        if (this.modalOnScreen()) {
          if (unlocked) html.classList.remove('tcc-vertical-unlock');
          return;
        }
        if (unlocked) return;
        const hs = getComputedStyle(html);
        const bs = getComputedStyle(body);
        const locked = hs.overflowY === 'hidden' || hs.overflowY === 'clip' || bs.overflowY === 'hidden' || bs.overflowY === 'clip' ||
          bs.position === 'fixed' || hs.touchAction === 'none' || bs.touchAction === 'none';
        if (locked) html.classList.add('tcc-vertical-unlock');
      }

      modalOnScreen() {
        if ((this.drawers || []).some((d) => d.open) || (this.lightbox && this.lightbox.open)) return true;
        const vw = window.innerWidth || 0;
        const vh = window.innerHeight || 0;
        return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"]')).some((el) => {
          if (this.contains(el)) return false;
          const r = el.getBoundingClientRect();
          if (r.width < 2 || r.height < 2 || r.right <= 0 || r.bottom <= 0 || r.left >= vw || r.top >= vh) return false;
          const cs = getComputedStyle(el);
          return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.05;
        });
      }

      unlockIfIdle() {
        const anyOpen = (this.drawers || []).some((d) => d.open) || (this.lightbox && this.lightbox.open);
        if (!anyOpen) document.documentElement.classList.remove('tcc-vertical-lock');
      }

      /* ---------- Signs checklist + result ---------- */
      initSigns() {
        this.signChecks = Array.from(this.querySelectorAll('[data-sign-check]'));
        this.signResults = Array.from(this.querySelectorAll('[data-sign-result]'));
        if (!this.signChecks.length && !this.signResults.length) return;
        this._signKey = 'tcc-vertical-signs-' + this.id_;
        let saved = [];
        try { saved = JSON.parse(sessionStorage.getItem(this._signKey) || '[]'); } catch (err) {}
        if (Array.isArray(saved) && saved.length) {
          this.signChecks.forEach((c) => { if (saved.indexOf(c.dataset.signId) > -1) c.checked = true; });
        }
        this.signUpdate(false);
      }

      signUpdate(save) {
        const checks = this.signChecks || [];
        const on = checks.filter((c) => c.checked);
        const count = on.length;
        checks.forEach((c) => {
          const row = c.closest('[data-sign-row]');
          if (row) row.classList.toggle('is-checked', c.checked);
        });
        if (save && this._signKey) {
          try { sessionStorage.setItem(this._signKey, JSON.stringify(on.map((c) => c.dataset.signId))); } catch (err) {}
        }
        (this.signResults || []).forEach((r) => {
          r.querySelectorAll('[data-sign-count]').forEach((el) => { el.textContent = count; });
          r.querySelectorAll('[data-sign-dot]').forEach((d, k) => { d.classList.toggle('is-on', k < count); });
          const vs = Array.from(r.querySelectorAll('[data-sres-v]'));
          const min = (v) => parseInt(v.dataset.min, 10) || 0;
          let pick = null;
          let low = null;
          vs.forEach((v) => {
            if (min(v) <= count && (!pick || min(v) >= min(pick))) pick = v;
            if (!low || min(v) < min(low)) low = v;
          });
          pick = pick || low;
          vs.forEach((v) => { v.hidden = v !== pick; });
          if (r.dataset.hideEmpty === 'true' && !this.design) {
            const step = r.closest('[data-step]');
            if (step) step.hidden = count === 0;
          }
        });
      }

      reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-marquee')) {
    customElements.define('tcc-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tcc-marquee__track');
        this.group = this.querySelector('.tcc-marquee__group:not([data-tcc-clone])');
        if (!this.track || !this.group) return;
        this.viewport = this.querySelector('.tcc-marquee__viewport') || this;

        this.setup = this.setup.bind(this);
        this.schedule = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(this.setup);
        };

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.schedule);
          this.ro.observe(this.viewport);
          this.ro.observe(this.group);
        }

        this.onSelect = (e) => { if (this.contains(e.target)) this.classList.add('is-paused'); };
        this.onDeselect = (e) => { if (this.contains(e.target)) this.classList.remove('is-paused'); };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);

        this.setup();
      }

      setup() {
        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        const needed = Math.max(2, Math.ceil(this.viewport.clientWidth / groupWidth) + 1);
        const clones = this.track.querySelectorAll('[data-tcc-clone]');

        if (clones.length + 1 !== needed) {
          clones.forEach((c) => c.remove());
          for (let i = 1; i < needed; i++) {
            const clone = this.group.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            clone.setAttribute('data-tcc-clone', '');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
            this.track.appendChild(clone);
          }
        }

        const speed = Math.max(1, Number(this.dataset.speed) || 50);
        this.track.style.setProperty('--tcc-distance', groupWidth + 'px');
        this.track.style.setProperty('--tcc-duration', (groupWidth / speed).toFixed(2) + 's');
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        cancelAnimationFrame(this.raf);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-pdp-arvertorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-adv-tally')) {
    customElements.define('tcc-adv-tally', class extends HTMLElement {
      connectedCallback() {
        this.onChange = (event) => {
          if (event.target.matches('[data-tcc-moment]')) this.update();
        };
        this.addEventListener('change', this.onChange);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }
      update() {
        const count = Array.from(this.querySelectorAll('[data-tcc-moment]')).filter((box) => box.checked).length;
        this.querySelectorAll('[data-tcc-count]').forEach((el) => { el.textContent = count; });
        this.querySelectorAll('[data-tcc-when]').forEach((el) => {
          el.hidden = el.dataset.tccWhen === 'any' ? count === 0 : count > 0;
        });
      }
    });
  }

  if (!customElements.get('tcc-adv-sticky')) {
    customElements.define('tcc-adv-sticky', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.tcc-adv');
        this.trigger = this.root.querySelector('[data-tcc-sticky-after]');
        this.hideWhen = Array.from(this.root.querySelectorAll('[data-tcc-sticky-hide]'));
        this.forced = false;
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this.update(); });
        };
        // Theme Editor: show the bar only while its own block is selected.
        this.onSelect = (event) => { this.forced = !!(event.detail && event.detail.blockId === this.dataset.blockId); this.update(); };
        this.onDeselect = () => { this.forced = false; this.update(); };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }
      update() {
        // Visible only once the block above the Sticky button block has scrolled past the top of the screen.
        // No block above it means no trigger, so the bar stays hidden.
        const passed = !!this.trigger && this.trigger.getBoundingClientRect().bottom < 0;
        // Step aside while a button marked "Hide sticky button while this button is on screen" is visible.
        const vh = window.innerHeight;
        const covered = this.hideWhen.some((el) => {
          const r = el.getBoundingClientRect();
          return r.width > 0 && r.bottom > 0 && r.top < vh;
        });
        const show = this.forced || (passed && !covered);
        this.classList.toggle('is-visible', show);
        this.inert = !show;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-product-information"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-product-info')) {
    class TccProductInfo extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-tcc-card]'));
        this.panels = Array.from(this.querySelectorAll('[data-tcc-panel]'));
        this.switchEl = this.querySelector('[data-tcc-switch]');
        this.form = this.querySelector('[data-tcc-form]');
        this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
        this.planInput = this.form ? this.form.querySelector('input[name="selling_plan"]') : null;
        this.atc = this.querySelector('[data-tcc-atc]');
        this.errorEl = this.querySelector('[data-tcc-error]');
        this.requiresPlan = this.dataset.requiresPlan === 'true';
        this.wantSub = this.dataset.defaultSub === 'true';
        const active = this.cards.findIndex((c) => c.classList.contains('is-active'));
        this.index = active > -1 ? active : 0;

        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);

        if (this.form && this.dataset.cartAction === 'drawer') {
          this.handleSubmit = this.handleSubmit.bind(this);
          this.form.addEventListener('submit', this.handleSubmit);
        }

        this.handleBlockSelect = (e) => {
          const card = e.target && e.target.closest ? e.target.closest('[data-tcc-card]') : null;
          if (card && this.contains(card)) { this.index = this.cards.indexOf(card); this.render(false); }
        };
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.convertComparePrices();
        this.initGallery();
        this.render(false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        if (this.form && this.handleSubmit) this.form.removeEventListener('submit', this.handleSubmit);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.track && this.handlePointerUp) {
          this.track.removeEventListener('pointerdown', this.handlePointerDown);
          this.track.removeEventListener('pointerup', this.handlePointerUp);
          this.track.removeEventListener('pointercancel', this.handlePointerCancel);
          this.track.removeEventListener('keydown', this.handleKey);
        }
      }

      /* Custom auto-ship compare prices are typed in the store currency: convert them for other markets */
      convertComparePrices() {
        const els = this.querySelectorAll('.tcc-pi__cmp.is-converting');
        if (!els.length) return;
        const cur = window.Shopify && window.Shopify.currency;
        const rate = cur ? parseFloat(cur.rate) : NaN;
        let fmt = null;
        try {
          fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur.active });
        } catch (err) { /* no formatter: hide below */ }
        els.forEach((el) => {
          const base = Number(el.dataset.tccBaseCents);
          if (!fmt || !(rate > 0) || !base) { el.hidden = true; return; }
          el.textContent = fmt.format(Math.round(base * rate) / 100);
          el.classList.remove('is-converting');
        });
      }

      handleClick(e) {
        const t = e.target;
        const card = t.closest('[data-tcc-card]');
        if (card) { this.index = this.cards.indexOf(card); this.render(true); return; }
        const canToggle = this.switchEl && !this.switchEl.disabled;
        if (t.closest('[data-tcc-switch]')) { if (canToggle) { this.wantSub = !this.sub; this.render(false); } return; }
        const modeBtn = t.closest('[data-tcc-set-mode]');
        if (modeBtn) { if (canToggle) { this.wantSub = modeBtn.dataset.tccSetMode === 'sub'; this.render(false); } return; }
        const arrow = t.closest('[data-tcc-dir]');
        if (arrow) { this.goTo(this.current + Number(arrow.dataset.tccDir)); return; }
        const thumb = t.closest('[data-tcc-thumb]');
        if (thumb) this.goTo(Number(thumb.dataset.tccThumb));
      }

      render(fromUser) {
        const card = this.cards[this.index];
        if (!card) return;
        this.cards.forEach((c, i) => {
          const on = i === this.index;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.panels.forEach((p) => { p.hidden = Number(p.dataset.tccPanel) !== this.index; });

        const planId = card.dataset.planId || '';
        const hasPlan = planId !== '';
        this.sub = hasPlan && (this.requiresPlan || this.wantSub);
        this.classList.toggle('tcc-pi--sub', this.sub);
        this.classList.toggle('tcc-pi--once', !this.sub);
        this.classList.toggle('tcc-pi--no-plan', !hasPlan);
        if (this.switchEl) {
          this.switchEl.setAttribute('aria-checked', String(this.sub));
          this.switchEl.disabled = !hasPlan || this.requiresPlan;
        }
        this.querySelectorAll('[data-tcc-percent]').forEach((el) => { el.textContent = card.dataset.percent || '0'; });
        this.querySelectorAll('[data-tcc-after-percent]').forEach((el) => { el.textContent = card.dataset.afterPercent || '0'; });

        const variantId = card.dataset.variantId || '';
        if (this.idInput) this.idInput.value = variantId;
        if (this.planInput) { this.planInput.value = planId; this.planInput.disabled = !this.sub; }
        if (this.atc) this.atc.disabled = !(variantId && card.dataset.available === 'true');
        if (this.errorEl) this.errorEl.hidden = true;

        if (!fromUser) return;
        if (variantId && this.dataset.updateUrl === 'true') {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url.toString());
          } catch (err) { /* ignore */ }
        }
        if (card.dataset.mediaId) this.goToMedia(card.dataset.mediaId);
        this.dispatchEvent(new CustomEvent('tcc:variant:change', {
          bubbles: true,
          detail: { variantId, sellingPlan: this.sub ? planId : null }
        }));
      }

      initGallery() {
        this.track = this.querySelector('[data-tcc-track]');
        this.thumbWrap = this.querySelector('[data-tcc-thumbs]');
        this.thumbs = Array.from(this.querySelectorAll('[data-tcc-thumb]'));
        this.current = 0;
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevBtn = this.querySelector('.tcc-pi__arrow--prev');
        this.nextBtn = this.querySelector('.tcc-pi__arrow--next');
        this.showSlide(0);
        this.updateArrows(0);

        this.handlePointerDown = (e) => {
          if (e.pointerType === 'mouse') return;
          this.startX = e.clientX;
          this.startY = e.clientY;
        };
        this.handlePointerUp = (e) => {
          if (this.startX == null) return;
          const dx = e.clientX - this.startX;
          const dy = e.clientY - this.startY;
          this.startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.goTo(this.current + (dx < 0 ? 1 : -1));
        };
        this.handlePointerCancel = () => { this.startX = null; };
        this.handleKey = (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.current - 1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.current + 1); }
        };
        this.track.addEventListener('pointerdown', this.handlePointerDown);
        this.track.addEventListener('pointerup', this.handlePointerUp);
        this.track.addEventListener('pointercancel', this.handlePointerCancel);
        this.track.addEventListener('keydown', this.handleKey);
      }

      showSlide(idx) {
        this.slides.forEach((s, k) => {
          const on = k === idx;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      }

      goTo(i) {
        if (!this.slides || !this.slides.length) return;
        const n = this.slides.length;
        const idx = ((i % n) + n) % n; /* loops: past the last goes to the first, before the first goes to the last */
        this.showSlide(idx);
        this.setActiveThumb(idx);
        this.updateArrows(idx);
      }

      updateArrows() {
        const single = this.slides.length < 2;
        if (this.prevBtn) this.prevBtn.disabled = single;
        if (this.nextBtn) this.nextBtn.disabled = single;
      }

      goToMedia(id) {
        if (!this.slides) return;
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
        if (i > -1) this.goTo(i);
      }

      setActiveThumb(i) {
        if (i === this.current && this.thumbs[i] && this.thumbs[i].classList.contains('is-active')) return;
        this.current = i;
        this.thumbs.forEach((t, k) => {
          const on = k === i;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        const t = this.thumbs[i];
        const c = this.thumbWrap;
        if (t && c) {
          c.scrollTo({
            top: t.offsetTop - (c.clientHeight - t.offsetHeight) / 2,
            left: t.offsetLeft - (c.clientWidth - t.offsetWidth) / 2
          });
        }
      }

      async handleSubmit(e) {
        e.preventDefault();
        if (!this.atc || this.atc.disabled || this.atc.classList.contains('is-loading')) return;
        this.atc.classList.add('is-loading');
        this.atc.setAttribute('aria-busy', 'true');
        if (this.errorEl) this.errorEl.hidden = true;

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
        const body = new FormData(this.form);
        if (canRender) {
          body.append('sections', cart.getSectionsToRender().map((s) => s.id));
          body.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.atc);
        }

        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            body,
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          document.dispatchEvent(new CustomEvent('tcc:cart:added', { detail: data }));
          if (canRender) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            window.location.href = root + 'cart';
          }
        } catch (err) {
          if (this.errorEl) { this.errorEl.textContent = err.message; this.errorEl.hidden = false; }
        } finally {
          this.atc.classList.remove('is-loading');
          this.atc.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('tcc-product-info', TccProductInfo);
  }

  /* Okendo group review count: loader until the group total arrives, product count as fallback */
  if (!window.tccOkendoGroupCount) {
    window.tccOkendoGroupCount = true;

    const tccFindCount = (obj) => {
      if (!obj || typeof obj !== 'object') return NaN;
      const keys = ['reviewCount', 'ratingAndReviewCount', 'totalReviews', 'review_count', 'count'];
      for (const k of keys) {
        const n = Number(obj[k]);
        if (obj[k] != null && !isNaN(n)) return n;
      }
      for (const v of Object.values(obj)) {
        const n = tccFindCount(v);
        if (!isNaN(n)) return n;
      }
      return NaN;
    };

    const tccFetchJson = async (url, withHeader) => {
      const res = await fetch(url, withHeader ? { headers: { 'okendo-api-version': '2025-02-01' } } : undefined);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    };

    const tccSetCount = (el, count) => {
      const out = el.querySelector('[data-tcc-review-count]');
      if (!out) return;
      const n = count > 0 ? count : Number(out.dataset.fallback || 0);
      el.removeAttribute('aria-busy');
      if (n > 0) {
        out.textContent = n;
        out.classList.remove('is-loading');
        out.classList.add('is-loaded');
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    };

    const tccLoadGroupCounts = () => {
      document.querySelectorAll('[data-tcc-okendo-group]:not([data-tcc-done])').forEach(async (el) => {
        el.setAttribute('data-tcc-done', '');
        const out = el.querySelector('[data-tcc-review-count]');
        const timer = setTimeout(() => {
          if (out && out.classList.contains('is-loading')) tccSetCount(el, NaN);
        }, 6000);

        const url = 'https://api.okendo.io/v1/stores/' + encodeURIComponent(el.dataset.tccOkendoUser.trim()) +
          '/collections/' + encodeURIComponent(el.dataset.tccOkendoGroup.trim()) + '/review_aggregate';
        let data;
        try {
          data = await tccFetchJson(url, true);
        } catch (err1) {
          try {
            data = await tccFetchJson(url, false);
          } catch (err2) {
            console.warn('[TCC Okendo] Request failed:', err1.message, '/', err2.message, url);
          }
        }
        clearTimeout(timer);
        tccSetCount(el, tccFindCount(data));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tccLoadGroupCounts);
    } else {
      tccLoadGroupCounts();
    }
    document.addEventListener('shopify:section:load', tccLoadGroupCounts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-revitalizing-formula"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tcc-revitalising-formula')) return;

    var SWIPER_VERSION = '11.1.14';
    var swiperPromise = null;

    function loadSwiper() {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (swiperPromise) return swiperPromise;

      swiperPromise = new Promise(function (resolve, reject) {
        var tries = 0;
        var poll = setInterval(function () {
          if (window.Swiper) {
            clearInterval(poll);
            resolve(window.Swiper);
          } else if (++tries > 20) {
            clearInterval(poll);
            inject();
          }
        }, 100);

        function inject() {
          var base = 'https://cdn.jsdelivr.net/npm/swiper@' + SWIPER_VERSION;
          if (!document.querySelector('link[data-tcc-swiper]')) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = base + '/swiper-bundle.min.css';
            link.setAttribute('data-tcc-swiper', '');
            document.head.appendChild(link);
          }
          var script = document.createElement('script');
          script.src = base + '/swiper-bundle.min.js';
          script.onload = function () {
            window.Swiper ? resolve(window.Swiper) : reject();
          };
          script.onerror = reject;
          document.head.appendChild(script);
        }
      });

      return swiperPromise;
    }

    class TccRevitalisingFormula extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-tcc-rf-list]');
        this.moreBtn = this.querySelector('[data-tcc-rf-more]');

        this.mq = window.matchMedia('(min-width: 641px)');
        this.onMqChange = this.maybeInitSlider.bind(this);
        this.mq.addEventListener('change', this.onMqChange);
        this.maybeInitSlider();

        if (this.moreBtn) {
          this.onMoreClick = this.expand.bind(this, true);
          this.moreBtn.addEventListener('click', this.onMoreClick);
        }

        this.onBlockSelect = this.handleBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.mq) this.mq.removeEventListener('change', this.onMqChange);
        if (this.moreBtn) this.moreBtn.removeEventListener('click', this.onMoreClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      maybeInitSlider() {
        if (!this.mq.matches || this.swiper || this.loading) return;
        var el = this.querySelector('.tcc-revitalising__slider');
        if (!el) return;

        this.loading = true;
        var self = this;

        loadSwiper()
          .then(function (Swiper) {
            self.loading = false;
            if (!self.isConnected || self.swiper) return;
            self.swiper = new Swiper(el, {
              speed: 800,
              slidesPerView: 3,
              spaceBetween: 22,
              grabCursor: true,
              observer: true,
              observeParents: true,
              pagination: {
                el: self.querySelector('.tcc-revitalising__pagination'),
                clickable: true
              },
              navigation: {
                nextEl: self.querySelector('.tcc-revitalising__nav--next'),
                prevEl: self.querySelector('.tcc-revitalising__nav--prev')
              },
              breakpoints: {
                0: { slidesPerView: 1, spaceBetween: 22 },
                640: { slidesPerView: 1.5, spaceBetween: 22 },
                768: { slidesPerView: 2, spaceBetween: 22 },
                950: { slidesPerView: 3, spaceBetween: 22 }
              }
            });
          })
          .catch(function () {
            self.loading = false;
          });
      }

      expand(moveFocus) {
        if (!this.list || this.list.classList.contains('is-expanded')) return;
        this.list.classList.add('is-expanded');

        if (this.moreBtn) {
          this.moreBtn.setAttribute('aria-expanded', 'true');
          this.moreBtn.hidden = true;
        }

        if (moveFocus === true) {
          var firstExtra = this.list.querySelector('.tcc-revitalising__item--extra summary');
          if (firstExtra) firstExtra.focus();
        }
      }

      handleBlockSelect(event) {
        var id = event.detail && event.detail.blockId;
        if (!id) return;

        var item = this.querySelector('.tcc-revitalising__item[data-block-id="' + id + '"]');
        if (!item) return;

        if (item.classList.contains('tcc-revitalising__item--extra')) this.expand(false);
        item.open = true;

        if (this.swiper) {
          var slides = Array.prototype.slice.call(this.querySelectorAll('.tcc-revitalising__slide'));
          var index = slides.findIndex(function (slide) {
            return slide.dataset.blockId === id;
          });
          if (index > -1) this.swiper.slideTo(index);
        }
      }
    }

    customElements.define('tcc-revitalising-formula', TccRevitalisingFormula);
  })();

  } catch(e) { console.error(e); }
})();
})();
